import React,{useEffect,useState} from 'react'
import {useLocation} from 'react-router-dom'


const ViewpdfReport = ()=> {
    const location = useLocation();
    const filecontent = location.state && location.state.ReportFile;
    const ReportData = location.state && location.state.ReportDetails;
    const [pdfDataUri,setPdfDataUri]= useState("")
    let count = 0;
    
    useEffect(()=>{
      if(count === 0){
        // let isOpened = false;
        console.log("filecontent",filecontent);
        const dataUri = `data:application/pdf;base64,${filecontent}`;
        console.log("dataUri",dataUri);
        setPdfDataUri(dataUri);

        count += 1;
      }
     
    },[]);

  return (
     <div>
      {pdfDataUri ? (
        <iframe
          title="PDF Viewer"
          width="100%"
          height="600px"
          src={`data:application/pdf;base64,${filecontent}`}
          frameBorder="0"
        />
      ) : (
        <p>Loading PDF...</p>
      )}
    </div>
  )
}

export default ViewpdfReport